import { filesize } from 'filesize'

export default function (fileSize?: number | null, fileExtension?: string | null) {
  return `${fileExtension ? fileExtension?.split('/')[1].toUpperCase() + ', ' : ''} ${fileSize ? filesize(fileSize, { round: 0 }) : ''}`
}
